import React from "react";

export default function Loader() {
  return (
    <div className="flex justify-center items-center">
      <div className="loading"></div>
    </div>
  );
}
